import { required } from 'vuelidate/lib/validators'
import { slugAsyncValidator, slugValidator, validationErrorMessages } from '@/utils/validations/validations'
import culturalOrganizationsSlugs from '@/services/gql/types/CulturalOrganizations/queries/culturalOrganizationsSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, culturalOrganizationsSlugs, ctx, 'culturalOrganizations')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    organizationName: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })(),
    description: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    shortDescription: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    }
  }
}
